<template>
  <v-toolbar class="primary darken-2">
    <v-row>
      <v-col class="px-0" cols="12">
        <v-row class="pl-2 mt-6" align="center">
          <v-icon
            class="mr-2"
            color="white"
            size="16"
            :style="`height: 24px; width: 24px; border-radius: 50%;background-color: ${basinIconColor};`"
            >{{ basinIconName }}</v-icon
          >
          <strong>{{ formTitle }}</strong>
          <v-tooltip
            max-width="380"
            nudge-left="170"
            top
            color="primary darken-1"
          >
            <template v-slot:activator="{on, attrs}">
              <v-icon
                class="ml-2"
                color="secondary lighten-1"
                v-bind="attrs"
                v-on="on"
                >mdi-help-circle-outline</v-icon
              >
            </template>
            <span
              class="my-4"
              style="
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 18px;
              "
            >
              Você também pode buscar a bacia pela localidade. Ao selecionar uma
              bacia, os dados abaixo serão atualizados.
            </span>
          </v-tooltip>
        </v-row>
        <v-autocomplete
          class="my-6"
          v-model="model"
          :items="result"
          :loading="isLoading"
          :search-input.sync="search"
          no-filter
          :hide-no-data="afterSearch"
          hide-selected
          hide-details
          item-text="text"
          prepend-inner-icon="search"
          return-object
          clearable
          clear-icon="mdi-backspace-outline"
          outlined
          item-color="secondary lighten-1"
          color="secondary lighten-1"
        >
          <template v-slot:no-data>
            <v-list-item v-show="!afterSearch">
              <v-list-item-title>
                <span class="error--text">Não encontrado.</span>
                <!--                <strong>Sugestões</strong>-->
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-toolbar>
</template>

<script>
export default {
  name: 'IndicatorsMapSearchForm',
  props: {
    basinId: {
      type: Number,
      default: 16,
      validator: (value) => [16, 17].indexOf(value) !== -1,
    },
    formTitle: {
      type: String,
      default: 'Busca por bacia de manancial',
    },
    basinIcon: {
      type: Object,
      default: () => ({name: 'icon-infohidro-bacia', color: '#69D7A3'}),
    },
    idClick: {
      type: Number,
    },
    from: {
      type: String,
    },
    category: {
      type: String,
    },
  },
  data: () => ({
    searchOption: 'Mananciais',
    result: [],
    searchHistoryUser: [],
    afterSearch: true,
    isLoading: false,
    search: '',
    model: null,
    onlyOnce: false,
  }),
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.basinId === 16) {
        await this.$store.dispatch('loadFountains', {customer_id: 7});
      } else {
        await this.$store.dispatch('loadReceivingBodies', {customer_id: 7});
      }
    },
    slugify(str) {
      str = str.toLowerCase();
      var from = 'àáãäâèéëêìíïîòóõöôùúüûç';
      var to = 'aaaaaeeeeiiiiooooouuuuc';
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
      return str;
    },
    checkEquality(val) {
      this.result = [];
      val = this.slugify(val);
      this.result = this.basins.filter((item) => {
        if (item.slug.includes(val)) {
          return item;
        }
      });
      if (this.result.length === 0) {
        this.afterSearch = false;
      } else {
        this.afterSearch = true;
      }
      this.isLoading = false;
    },
  },
  computed: {
    basins() {
      const basinsList =
        this.basinId === 16
          ? this.$store.getters.fountains
          : this.$store.getters.receivingBodies;
      const resultList = [];
      for (const basinKey in basinsList) {
        const slug = this.slugify(basinsList[basinKey].locationname);
        const holder = {
          text: basinsList[basinKey].locationname,
          locationid: basinsList[basinKey].locationid,
          customerid: basinsList[basinKey].customerid,
          slug: slug,
        };
        resultList.push(holder);
      }
      return resultList;
    },
    searchedBasinsPoints() {
      const captationPoints = this.$store.getters.searchedCaptationPoints;
      const effluentPoints = this.$store.getters.searchedEffluentPoints;

      return this.basinId === 16 ? captationPoints : effluentPoints;
    },
    basinIconName() {
      return this.basinIcon && this.basinIcon.name
        ? this.basinIcon.name
        : 'icon-infohidro-bacia';
    },
    basinIconColor() {
      return this.basinIcon && this.basinIcon.color
        ? this.basinIcon.color
        : '#69D7A3';
    },
  },
  watch: {
    idClick(id) {
      if (id) {
        let found = this.basins.find((item) => item.locationid === id);
        this.model = found;
      }
    },
    model(val) {
      if (val) {
        if (!this.onlyOnce) {
          this.onlyOnce = true;
        } else {
          this.searchHistoryUser.push(val);
        }
        if (this.searchHistoryUser) {
          if (this.searchHistoryUser.length === 4) {
            this.searchHistoryUser.shift();
          }
        }

        let parameter =
          'https://produtos.simepar.br/geosimepar/forecastdev/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=forecastdev:customer_subbasin&outputFormat=application%2Fjson&cql_filter=sbsid=' +
          val.locationid +
          '&viewparams=customer_id:' +
          val.customerid;
        this.$emit('result', parameter);
        this.$emit('resultLocation', val);
        this.$store.dispatch('saveInCacheSearchedBasinsPoints', {
          searchedBasinPoint: val,
          basinId: this.basinId,
        });

        var event_name = 'search_' + this.from + '-' + this.category;
        this.$gtag.event(event_name, {
          event_category: this.category,
          event_label: 'search_locationid',
          value: val.locationid,
        });
      }
    },
    search(val) {
      if (!val) {
        if (this.searchedBasinsPoints.length >= 1) {
          this.result = this.searchedBasinsPoints;
        } else {
          this.result = this.basins.slice(0, 3);
        }
      }
      if (val) {
        if (val.length < 2) {
          if (this.searchedBasinsPoints.length >= 1) {
            this.result = this.searchedBasinsPoints;
          } else {
            this.result = this.basins.slice(0, 3);
          }
        }
        if (val.length >= 2) {
          this.isLoading = true;
          setTimeout(() => {
            this.checkEquality(val);
          }, 2000);
        }
      }
    },
  },
};
</script>
<style scoped></style>
